"use strict";
/**
 * This module re-exports Dimensionsless from Unit and adds some extra units
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPM = exports.Percent = exports.One = void 0;
var uom_1 = require("uom");
exports.One = uom_1.Unit.One;
exports.Percent = uom_1.Unit.divideNumber("Percent", 100.0, uom_1.Unit.One);
exports.PPM = uom_1.Unit.divideNumber("PPM", 1000000.0, uom_1.Unit.One);
//# sourceMappingURL=dimensionless.js.map